export default __webpack_public_path__ + "static/media/gallery_03.e9c70f21.jpg";